var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1486"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 363",
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2 11.775a1.575 1.575 0 001.114-2.689 1.575 1.575 0 00-2.227 2.227 1.518 1.518 0 001.113.462zm0 7.448a26.352 26.352 0 004.421-4.939 7.493 7.493 0 001.429-3.9 5.857 5.857 0 00-1.7-4.342A5.666 5.666 0 0012.2 4.35a5.666 5.666 0 00-4.151 1.688 5.857 5.857 0 00-1.7 4.342 7.383 7.383 0 001.462 3.9 28.616 28.616 0 004.389 4.942zm0 1.777a29.919 29.919 0 01-5.411-5.726A8.9 8.9 0 015 10.38 6.96 6.96 0 017.171 5a7.315 7.315 0 0110.058 0 6.96 6.96 0 012.171 5.38 8.9 8.9 0 01-1.789 4.894A29.919 29.919 0 0112.2 21zm0-10.62z",
    fill: "#444"
  }))));
}
export default SvgLocation;